var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"dom-head",style:({
  gridColumn: _vm.pos[0], gridRow: _vm.pos[1],
})},[_c('img',{staticClass:"head",style:({
    transform: ("rotate(" + _vm.rotate + "deg)"),
  }),attrs:{"src":_vm.src}}),(_vm.vomit)?_c('img',{staticClass:"vomit",style:(_vm.vomitStyle),attrs:{"src":require("@/assets/vomit.gif")}}):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }